import { DecimalPipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { APP_CONSTANTS as CONST } from '@app/app.constants';
import { APP_ROUTES } from '@app/app.routes';
import { PreviewOffer } from '@app/core/models/offers.model';
import { Summary } from '@app/core/models/summary.model';
import { PowerpayCurrencyPipe } from '@app/presentation/mo-layout/pipes/powerpay-currency.pipe';
import { UtilService } from '@app/services/util.service';
import { OffersService } from '../offers.service';

@Injectable({
  providedIn: 'root',
})
export class PaymentService {
  public CONST = CONST;

  constructor(
    private _decimalPipe: DecimalPipe,
    private _powerpayCurrencyPipe: PowerpayCurrencyPipe,
    private _utilService: UtilService,
    private _offersService: OffersService
  ) {}

  public handlePaymentIfHasCard() {
    const route: string = APP_ROUTES.PAYMENT_METHOD;
    return this._utilService.navigateTo(route);
  }

  public getBinesFromCreditCardInfo(creditCardInfo): string {
    return creditCardInfo?.card_number.toString().slice(0, 6);
  }

  public getSummaryByPreviewOfferAndAmount(amount: string, previewOffer: PreviewOffer): Summary {
    return [
      {
        name: 'Monto de tu compra',
        value: `${this._formatAmount(amount)}`,
      },
      {
        name: 'TCEA',
        value: `${this._formatPercent(previewOffer?.details.tcea.toString())} %`,
        tooltip:
          'La comisión de nuestro servicio es un solo costo que es una fracción en el pago en 6 o 12 cuotas. En el pago en 3 cuotas no cobramos ninguna tasa o comisión.',
      },
      {
        name: 'Total a pagar',
        value: `${this._setTotalCosts(previewOffer, amount).toString()}`,
        isTotal: true,
      },
      {
        name: 'Total a pagar',
        value: `(Incluye comisión Powerpay de ${this._setTotalCostWithTaxesInstallment(
          previewOffer?.details.total_costs,
          previewOffer?.details.total_taxes,
          previewOffer?.installments.length
        )} por cuota)`,
        isInformative: true,
      },
    ];
  }
  private _setTotalCostWithTaxesInstallment(
    totalCost: string,
    totalTaxes: string,
    installments: number
  ): string {
    const totalCostWithTaxes: number = Number(totalCost) + Number(totalTaxes);
    const totalCostWithTaxesInstallment: number = totalCostWithTaxes / installments;
    return this._formatAmount(totalCostWithTaxesInstallment.toString());
  }
  private _formatAmount(value: string): string {
    return this._powerpayCurrencyPipe.transform(value);
  }

  private _formatPercent(value: string): string {
    return this._decimalPipe.transform(Number(value), '1.2-2', 'en-US');
  }

  private _setTotalCosts(previewOffer: PreviewOffer, amount: string): string {
    const totalCostWithTaxes = this._offersService.setTotalCostWithTaxes(
      previewOffer?.details.total_costs,
      previewOffer?.details.total_taxes
    );

    return this._formatAmount((Number(totalCostWithTaxes) + Number(amount)).toString());
  }
}
